import React, { useState } from 'react';

const QuickAddVineyardModal = ({ show, onClose, onSave, companies = [] }) => {
    const [newVineyard, setNewVineyard] = useState({
        companyID: '',
        vineyardName: '',
        vinAppellation: '',
        vinSubAppellation: '',
        vinBlock: '',
        location: '',
        acreage: '',
        varietals: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        
        try {
            await onSave(newVineyard);
            onClose();
            setNewVineyard({
                companyID: '',
                vineyardName: '',
                vinAppellation: '',
                vinSubAppellation: '',
                vinBlock: '',
                location: '',
                acreage: '',
                varietals: ''
            });
        } catch (err) {
            setError('Failed to create vineyard. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Quick Add Vineyard</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                disabled={loading}
                            ></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                {error && (
                                    <div className="alert alert-danger">{error}</div>
                                )}
                                
                                <div className="mb-3">
                                    <label className="form-label">Company/Grower *</label>
                                    <select
                                        className="form-control"
                                        value={newVineyard.companyID}
                                        onChange={(e) => setNewVineyard({
                                            ...newVineyard,
                                            companyID: e.target.value
                                        })}
                                        required
                                    >
                                        <option value="">Select Company</option>
                                        {companies.map(company => (
                                            <option key={company.id} value={company.id}>
                                                {company.companyName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Vineyard Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={newVineyard.vineyardName}
                                        onChange={(e) => setNewVineyard({
                                            ...newVineyard,
                                            vineyardName: e.target.value
                                        })}
                                        required
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Appellation</label>
                                        <select
                                            className="form-control"
                                            value={newVineyard.vinAppellation}
                                            onChange={(e) => setNewVineyard({
                                                ...newVineyard,
                                                vinAppellation: e.target.value
                                            })}
                                        >
                                            <option value="">Select Appellation</option>
                                            <option value="Lodi">Lodi</option>
                                            <option value="California">California</option>
                                            <option value="Amador County">Amador County</option>
                                            <option value="Napa">Napa</option>
                                            <option value="Sonoma">Sonoma</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Sub-Appellation</label>
                                        <select
                                            className="form-control"
                                            value={newVineyard.vinSubAppellation}
                                            onChange={(e) => setNewVineyard({
                                                ...newVineyard,
                                                vinSubAppellation: e.target.value
                                            })}
                                        >
                                            <option value="">Select Sub-Appellation</option>
                                            <option value="Alta Mesa">Alta Mesa</option>
                                            <option value="Borden Ranch">Borden Ranch</option>
                                            <option value="Clements Hills">Clements Hills</option>
                                            <option value="Cosumnes River">Cosumnes River</option>
                                            <option value="Jahant">Jahant</option>
                                            <option value="Mokelumne River">Mokelumne River</option>
                                            <option value="Sloughhouse">Sloughhouse</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Block</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={newVineyard.vinBlock}
                                        onChange={(e) => setNewVineyard({
                                            ...newVineyard,
                                            vinBlock: e.target.value
                                        })}
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Location Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newVineyard.location}
                                            onChange={(e) => setNewVineyard({
                                                ...newVineyard,
                                                location: e.target.value
                                            })}
                                            placeholder="e.g., Southeast Corner"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Acreage</label>
                                        <input
                                            type="number"
                                            step="0.1"
                                            className="form-control"
                                            value={newVineyard.acreage}
                                            onChange={(e) => setNewVineyard({
                                                ...newVineyard,
                                                acreage: e.target.value
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? 'Creating...' : 'Create Vineyard'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuickAddVineyardModal;